module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-groengrijs.69f411f0.svg";